import React from 'react';

const LIGHT_PATTERN_SVG = `<svg width="1200" height="220" viewBox="0 0 1200 220" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="24" width="18" height="84" rx="2" fill="#ECECEC" /><rect x="40" y="8" width="18" height="56" rx="2" fill="#ECECEC" /><rect x="80" y="36" width="18" height="96" rx="2" fill="#ECECEC" /><rect x="120" y="0" width="18" height="140" rx="2" fill="#ECECEC" /><rect x="160" y="20" width="18" height="72" rx="2" fill="#ECECEC" /><rect x="200" y="60" width="18" height="90" rx="2" fill="#ECECEC" /><rect x="240" y="12" width="18" height="120" rx="2" fill="#ECECEC" /><rect x="280" y="46" width="18" height="64" rx="2" fill="#ECECEC" /><rect x="320" y="0" width="18" height="180" rx="2" fill="#ECECEC" /><rect x="360" y="28" width="18" height="92" rx="2" fill="#ECECEC" /><rect x="400" y="64" width="18" height="64" rx="2" fill="#ECECEC" /><rect x="440" y="18" width="18" height="140" rx="2" fill="#ECECEC" /><rect x="480" y="56" width="18" height="72" rx="2" fill="#ECECEC" /><rect x="520" y="0" width="18" height="112" rx="2" fill="#ECECEC" /><rect x="560" y="34" width="18" height="88" rx="2" fill="#ECECEC" /><rect x="600" y="70" width="18" height="96" rx="2" fill="#ECECEC" /><rect x="640" y="14" width="18" height="132" rx="2" fill="#ECECEC" /><rect x="680" y="50" width="18" height="70" rx="2" fill="#ECECEC" /><rect x="720" y="0" width="18" height="160" rx="2" fill="#ECECEC" /><rect x="760" y="22" width="18" height="92" rx="2" fill="#ECECEC" /><rect x="800" y="48" width="18" height="108" rx="2" fill="#ECECEC" /><rect x="840" y="10" width="18" height="122" rx="2" fill="#ECECEC" /><rect x="880" y="62" width="18" height="70" rx="2" fill="#ECECEC" /><rect x="920" y="26" width="18" height="94" rx="2" fill="#ECECEC" /><rect x="960" y="0" width="18" height="136" rx="2" fill="#ECECEC" /><rect x="1000" y="32" width="18" height="86" rx="2" fill="#ECECEC" /><rect x="1040" y="58" width="18" height="94" rx="2" fill="#ECECEC" /><rect x="1080" y="12" width="18" height="116" rx="2" fill="#ECECEC" /><rect x="1120" y="44" width="18" height="74" rx="2" fill="#ECECEC" /><rect x="1160" y="0" width="18" height="152" rx="2" fill="#ECECEC" /></svg>`;
const DARK_PATTERN_SVG = `<svg width="1200" height="220" viewBox="0 0 1200 220" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="24" width="18" height="84" rx="2" fill="#2A2A2A" /><rect x="40" y="8" width="18" height="56" rx="2" fill="#2A2A2A" /><rect x="80" y="36" width="18" height="96" rx="2" fill="#2A2A2A" /><rect x="120" y="0" width="18" height="140" rx="2" fill="#2A2A2A" /><rect x="160" y="20" width="18" height="72" rx="2" fill="#2A2A2A" /><rect x="200" y="60" width="18" height="90" rx="2" fill="#2A2A2A" /><rect x="240" y="12" width="18" height="120" rx="2" fill="#2A2A2A" /><rect x="280" y="46" width="18" height="64" rx="2" fill="#2A2A2A" /><rect x="320" y="0" width="18" height="180" rx="2" fill="#2A2A2A" /><rect x="360" y="28" width="18" height="92" rx="2" fill="#2A2A2A" /><rect x="400" y="64" width="18" height="64" rx="2" fill="#2A2A2A" /><rect x="440" y="18" width="18" height="140" rx="2" fill="#2A2A2A" /><rect x="480" y="56" width="18" height="72" rx="2" fill="#2A2A2A" /><rect x="520" y="0" width="18" height="112" rx="2" fill="#2A2A2A" /><rect x="560" y="34" width="18" height="88" rx="2" fill="#2A2A2A" /><rect x="600" y="70" width="18" height="96" rx="2" fill="#2A2A2A" /><rect x="640" y="14" width="18" height="132" rx="2" fill="#2A2A2A" /><rect x="680" y="50" width="18" height="70" rx="2" fill="#2A2A2A" /><rect x="720" y="0" width="18" height="160" rx="2" fill="#2A2A2A" /><rect x="760" y="22" width="18" height="92" rx="2" fill="#2A2A2A" /><rect x="800" y="48" width="18" height="108" rx="2" fill="#2A2A2A" /><rect x="840" y="10" width="18" height="122" rx="2" fill="#2A2A2A" /><rect x="880" y="62" width="18" height="70" rx="2" fill="#2A2A2A" /><rect x="920" y="26" width="18" height="94" rx="2" fill="#2A2A2A" /><rect x="960" y="0" width="18" height="136" rx="2" fill="#2A2A2A" /><rect x="1000" y="32" width="18" height="86" rx="2" fill="#2A2A2A" /><rect x="1040" y="58" width="18" height="94" rx="2" fill="#2A2A2A" /><rect x="1080" y="12" width="18" height="116" rx="2" fill="#2A2A2A" /><rect x="1120" y="44" width="18" height="74" rx="2" fill="#2A2A2A" /><rect x="1160" y="0" width="18" height="152" rx="2" fill="#2A2A2A" /></svg>`;

const lightPatternUrl = `url("data:image/svg+xml,${encodeURIComponent(LIGHT_PATTERN_SVG)}")`;
const darkPatternUrl = `url("data:image/svg+xml,${encodeURIComponent(DARK_PATTERN_SVG)}")`;

const shellStyle = (isDark) => ({
    position: 'relative',
    display: 'flex',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    padding: '0 24px',
    textAlign: 'center',
    boxSizing: 'border-box',
    background: isDark ? '#09090b' : '#ffffff'
});

const patternStyle = (isDark, flip) => ({
    pointerEvents: 'none',
    position: 'absolute',
    left: 0,
    right: 0,
    height: '224px',
    opacity: 0.7,
    backgroundImage: isDark ? darkPatternUrl : lightPatternUrl,
    backgroundPosition: 'top center',
    backgroundRepeat: 'repeat-x',
    transform: flip ? 'scaleY(-1)' : 'none'
});

const cardStyle = {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    width: '100%',
    maxWidth: '672px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px'
};

const headingStyle = (isDark) => ({
    margin: 0,
    fontSize: '128px',
    lineHeight: 1,
    fontWeight: 700,
    color: isDark ? 'rgb(255 255 255 / 0.1)' : '#d4d4d8'
});

const messageStyle = {
    margin: 0,
    width: '100%',
    maxWidth: '449px',
    color: '#737373',
    fontSize: '20px',
    lineHeight: '28px'
};

const titleStyle = (isDark) => ({
    margin: 0,
    color: isDark ? '#f4f4f5' : '#18181b',
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: '34px'
});

const actionsStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '12px'
};

const buttonStyle = (variant = 'primary', isDark = false) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '151px',
    gap: '8px',
    height: '36px',
    padding: '0 24px',
    border: variant === 'primary' ? 0 : `1px solid ${isDark ? '#3f3f46' : '#d4d4d8'}`,
    borderRadius: '8px',
    background: variant === 'primary' ? '#2563eb' : 'transparent',
    color: variant === 'primary' ? '#ffffff' : isDark ? '#e4e4e7' : '#52525b',
    fontFamily: '"IBM Plex Sans", sans-serif',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    boxSizing: 'border-box',
    cursor: 'pointer'
});

const logoStyle = {
    width: '100%',
    height: 'auto',
    display: 'block'
};

const isCallable = (value) => typeof value === 'function';

function StatusAction({ href, isDark, label, onClick, variant }) {
    if (!label) {
        return null;
    }

    const style = buttonStyle(variant, isDark);

    if (href && !onClick) {
        return React.createElement(
            'a',
            {
                href,
                style: {
                    ...style,
                    textDecoration: 'none'
                }
            },
            label
        );
    }

    return React.createElement(
        'button',
        {
            type: 'button',
            onClick,
            style
        },
        label
    );
}

function SharedStatusPage({
    appName = 'home',
    homeHref = '/',
    logoSrc,
    darkLogoSrc,
    logoAlt = 'Logo',
    logoWidth = 198,
    statusCode = '404',
    title,
    description,
    primaryActionLabel = 'Take me home',
    onPrimaryAction,
    primaryActionHref,
    secondaryActionLabel,
    onSecondaryAction,
    secondaryActionHref
}) {
    const [isDark, setIsDark] = React.useState(false);

    React.useEffect(() => {
        if (typeof window === 'undefined') return;

        const storedTheme = window.localStorage.getItem('theme');
        const nextIsDark =
            storedTheme === 'dark' ||
            (!storedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches);

        setIsDark(nextIsDark);
    }, []);

    const copy = description || "Sorry, the page you're looking for couldn't be found.";

    const handleTakeMeHome = () => {
        if (typeof window === 'undefined') return;
        window.location.assign(homeHref);
    };

    const primaryHandler = isCallable(onPrimaryAction) ? onPrimaryAction : handleTakeMeHome;
    const primaryHref = primaryActionHref || (!isCallable(onPrimaryAction) ? homeHref : undefined);

    return React.createElement(
        'main',
        { style: shellStyle(isDark) },
        React.createElement('div', {
            style: { ...patternStyle(isDark, false), top: 0 },
            'aria-hidden': 'true'
        }),
        React.createElement('div', {
            style: { ...patternStyle(isDark, true), bottom: 0 },
            'aria-hidden': 'true'
        }),
        React.createElement(
            'div',
            { style: cardStyle },
            logoSrc
                ? React.createElement(
                      'a',
                      {
                          href: homeHref,
                          'aria-label': `${appName} home`,
                          style: {
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                          }
                      },
                      React.createElement('img', {
                          src: isDark && darkLogoSrc ? darkLogoSrc : logoSrc,
                          alt: logoAlt,
                          style: { ...logoStyle, maxWidth: `${logoWidth}px` }
                      })
                  )
                : null,
            React.createElement('h1', { style: headingStyle(isDark) }, statusCode),
            title ? React.createElement('h2', { style: titleStyle(isDark) }, title) : null,
            React.createElement('p', { style: messageStyle }, copy),
            React.createElement(
                'div',
                { style: actionsStyle },
                React.createElement(StatusAction, {
                    href: primaryHref,
                    isDark,
                    label: primaryActionLabel,
                    onClick: primaryHandler,
                    variant: 'primary'
                }),
                React.createElement(StatusAction, {
                    href: secondaryActionHref,
                    isDark,
                    label: secondaryActionLabel,
                    onClick: onSecondaryAction,
                    variant: 'secondary'
                })
            )
        )
    );
}

function SharedNotFoundPage(props = {}) {
    return React.createElement(SharedStatusPage, {
        ...props,
        statusCode: props.statusCode || '404',
        description:
            props.description ||
            "Sorry, the page you're looking for couldn't be found. Please return to the homepage.",
        primaryActionLabel: props.primaryActionLabel || 'Take me home'
    });
}

function SharedErrorPage(props = {}) {
    const retry = () => {
        if (isCallable(props.onPrimaryAction)) {
            props.onPrimaryAction();
            return;
        }

        if (typeof window !== 'undefined') {
            window.location.reload();
        }
    };

    return React.createElement(SharedStatusPage, {
        ...props,
        statusCode: props.statusCode || '500',
        title: props.title || 'Something went wrong',
        description:
            props.description ||
            'We hit an unexpected issue. Please try again or return to the homepage.',
        primaryActionLabel: props.primaryActionLabel || 'Try again',
        onPrimaryAction: retry,
        secondaryActionLabel: props.secondaryActionLabel || 'Take me home',
        secondaryActionHref: props.secondaryActionHref || props.homeHref || '/'
    });
}

export { SharedErrorPage, SharedStatusPage };
export default SharedNotFoundPage;
